// extracted by mini-css-extract-plugin
module.exports = {"modal":"WRI6p","root":"_2pgVw","video":"_23cn9","iframe":"_1Z4LT","close":"_3E7L1","closeIcon":"_2Kloh"};